import React from 'react';
import styled from 'styled-components';
import {
  BucketKind,
  INamedBucketDefFieldsFragment,
} from '../../../../../utils/apollo/graphqlSchema';
import { PrimaryButton } from '../../../../Button';
import BuilderBinning from '../BuilderBinning';

interface IBinningPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  validBinning: boolean;
  onSubmit: () => void;
}

interface IHistogramBinningProps extends IBinningPopoverProps {
  type: 'histogramBinning';
  supportedBucketKinds: BucketKind[];
  defaultNamedBucketDef: INamedBucketDefFieldsFragment | null;
}

interface IBreakdownBinningProps extends IBinningPopoverProps {
  type: 'breakdownBinning';
  supportedBucketKinds: BucketKind[];
  selectedFieldKey: string;
  groupIndex: number;
  defaultNamedBucketDef: INamedBucketDefFieldsFragment | null;
}

type IProps = IHistogramBinningProps | IBreakdownBinningProps;

const Container = styled.div`
  width: 264px;
  padding: 12px;
`;

const Footer = styled.div`
  margin-top: 16px;
  text-align: right;
`;

const BinningPopover = ({
  isOpen,
  onClose,
  validBinning,
  onSubmit,
  ...props
}: IProps) => {
  return (
    <Container>
      <BuilderBinning
        {...props}
        // In Histogram only range binnings are supported,
        // selectedFieldKey is important for enums
        selectedFieldKey={
          props.type === 'histogramBinning' ? null : props.selectedFieldKey
        }
      />
      <Footer>
        <PrimaryButton
          type="button"
          disabled={!validBinning}
          onClick={onSubmit}
          trackContext="binning"
          trackAction="confirm"
        >
          Confirm
        </PrimaryButton>
      </Footer>
    </Container>
  );
};

export default BinningPopover;
